import React from "react";
import reports from "../../../assets/img/reports.svg";
import analyse from "../../../assets/img/analyse.svg";
import sales from "../../../assets/img/sales.svg";
import overview from "../../../assets/img/overview.svg";
import { dashboardColors, theme } from "../../../themes/Theme";

const ReportsEmptyState = () => {
  return (
    <div className="reports_main_container h-100">
      <div className="report-empty-reports_card">
        <div className="report-empty-reports_icon">
          <img src={reports} alt="Reports" />
        </div>

        <h3 className="report-empty-reports_title">Reports</h3>
        <p className="report-empty-reports_desc">
          Get valuable insights with visual reports that help you track payments, revenue,
          and performance trends across all your events.
        </p>

        <div className="report-empty-reports_features">
          <div className="report-empty-feature_item">
            <img src={analyse} alt="Analyse & Compare" className="feature_icon" />

            <div>
              <h4 className="report-empty-feature_title">Get Overview</h4>
              <p className="report-empty-feature_desc">
                Get a complete view of your event’s performance—all in one place.
              </p>
            </div>
          </div>

          <div className="report-empty-feature_item">
            <img src={sales} alt="Get Sales Insights" className="feature_icon" />
            <div>
              <h4 className="report-empty-feature_title">Get Sales Insights</h4>
              <p className="report-empty-feature_desc">
                Monitor revenue and transaction insights across multiple events.
              </p>
            </div>
          </div>

          <div className="report-empty-feature_item">
            <img src={overview} alt="Get Overview" className="feature_icon" />

            <div>
              <h4 className="report-empty-feature_title">Analyse & Compare</h4>
              <p className="report-empty-feature_desc">
                View visual reports and breakdowns to track trends, compare performance,
                and make informed decisions.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .report-empty-reports_card {
            text-align: center;
            padding: 25px 30px;
            border: 1px dashed #C3CDDF;
            background: #fff;
            max-width:700px;
            margin:auto;
          }

          .report-empty-reports_icon img {
            width: 48px;
            height: 48px;
            margin-bottom: 15px;
          }
          .reports_main_container{
            margin: 0 !important;
                    border-radius: 0px;
                    background-color: #fff;
                    padding: 30px;
                    overflow-y: auto;
          }

          .report-empty-reports_title {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
            color: ${dashboardColors[theme].primaryTextColor};
          }

          .report-empty-reports_desc {
            font-size: 14px;
            color: ${dashboardColors[theme].primaryTextColor};
            margin-bottom: 20px;
          }

          .report-empty-reports_features {
            background: #fff;
            padding: 16px 20px;
            border-radius: 6px;
            text-align: left;
            box-shadow: 0px 0px 12px 9px #002E6E14;
          }

          .report-empty-feature_item {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 20px;
          }

          .feature_icon {
            width: 28px;
            height: 28px;
            flex-shrink: 0;
          }

          .report-empty-feature_title {
            font-size: 16px;
            font-weight: 500;
            margin: 0 0 5px;
          }

          .report-empty-feature_desc {
            font-size: 14px;
            color: ${dashboardColors[theme].primaryTextColor};
            margin: 0;
          }
        `}
      </style>
    </div>
  );
};

export default ReportsEmptyState;
